<template>
  <div class="foot w_100">
    <div class="centent auto">
      <div class="topBox flex align_c justify_around">
        <div class="icons flex align_c">
          <img src="../assets/foot_1.png" alt="" />
          <span>专业生产，品质保障</span>
        </div>
        <div class="icons flex align_c">
          <img src="../assets/foot_2.png" alt="" />
          <span>放心购物，急速配送</span>
        </div>
        <div class="icons flex align_c">
          <img src="../assets/foot_3.png" alt="" />
          <span>贴心服务，售后无忧</span>
        </div>
      </div>
      <div class="bottomBox flex justify_evenly">
        <div class="footNav flex flex_column">
          <div class="tit">购物指南</div>
          <div class="item cursor hover" @click="jumpto('/footPage?id=1')">
            购买流程
          </div>
          <div class="item cursor hover" @click="jumpto('/footPage?id=2')">
            配送方式
          </div>
          <div class="item cursor hover" @click="jumpto('/footPage?id=3')">
            付款方式
          </div>
          <div class="item cursor hover" @click="jumpto('/footPage?id=4')">
            发票说明
          </div>
        </div>
        <div class="line"></div>
        <div class="footNav flex flex_column">
          <div class="tit">售后服务</div>
          <div class="item cursor hover" @click="jumpto('/footPage?id=5')">
            服务协议
          </div>
          <div class="item cursor hover" @click="jumpto('/footPage?id=6')">
            隐私政策
          </div>
          <div class="item cursor hover" @click="jumpto('/footPage?id=7')">
            售后政策
          </div>
          <!-- <div class="item cursor hover">返还退货</div> -->
        </div>
        <div class="line"></div>
        <div class="footNav flex flex_column">
          <div class="tit">友情链接</div>
          <div class="flex flex_column" style="height: 100px; flex-wrap: wrap">
            <a
              class="item cursor hover"
              v-for="(item, index) in urlList"
              :key="index"
              :href="item.url"
            >
              {{ item.title }}
            </a>
          </div>
        </div>
        <div class="line"></div>
        <div class="footInfo flex flex_column justify_between">
          <div class="phone">
            <div class="left">
              <img src="" alt="" />
            </div>
            <div class="right">
              <div>服务热线</div>
              <div>{{ info.phone }}</div>
            </div>
          </div>
          <div class="item ad">地址：{{ info.localhost }}</div>
          <div class="item email">邮箱：{{ info.email }}</div>
        </div>
        <div class="ewm flex flex_column justify_between align_c">
          <img :src="info.erweima" alt="" />
          <div>关注我们</div>
        </div>
      </div>
      <div class="icp">{{ arrinfo.shop }}</div>
      <div class="icp">
        <img src="" alt="" />
        <img src="" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import { getCompany, index, getUrl } from '../api/basisMG'
export default {
  name: 'foot',
  props: {},
  data() {
    return {
      info: '',
      arrinfo: '',
      urlList: [],
    }
  },
  mounted() {
    this.getIndex()
    this.getUrl()
  },
  methods: {
    getUrl() {
      getUrl().then((res) => {
        this.urlList = res.data
      })
    },
    getIndex() {
      getCompany().then((res) => {
        if (res.code == 1) {
          this.info = res.data
        } else {
          this.$notify.error({
            title: '错误',
            message: res.msg,
          })
        }
      })
      index().then((res) => {
        if (res.code == 1) {
          this.arrinfo = res.data
        } else {
          this.$notify.error({
            title: '错误',
            message: res.msg,
          })
        }
      })
    },
    // jumpto(page) {
    //   this.$router.push({ path: page });
    // },
    jumpto(page) {
      const routeData = {
        path: page,
      }
      const resolvedRoute = this.$router.resolve(routeData)
      window.open(resolvedRoute.href, '_blank')
    },
  },
}
</script>
<style lang="scss" scoped>
.foot {
  background: url(../assets/footbg.png) no-repeat;
  background-size: 100% 100%;
  * {
    color: #fff;
    a {
      text-decoration: none;
    }
  }
  .centent {
    max-width: $max_width;
    min-width: $min_width;
    padding: 20px 0;
    .topBox {
      border-bottom: #fff 1px solid;
      padding-bottom: 20px;
      margin-bottom: 20px;
      .icons {
        img {
          margin-right: 10px;
          width: 35px;
          height: 35px;
        }
      }
    }
    .bottomBox {
      margin-bottom: 20px;
      .footNav {
        .tit {
          margin-bottom: 10px;
        }
        .item {
          font-size: 13px;
          margin-bottom: 5px;
        }
      }
      .footInfo {
        .item {
          font-size: 13px;
        }
      }
      .line {
        height: auto;
      }
      .ewm {
        img {
          width: 100px;
          margin-bottom: 10px;
        }
      }
    }
    .icp {
      text-align: center;
      img {
        width: 20px;
        margin-top: 10px;
      }
    }
  }
}
</style>
